"use client";

import { getStatusUrl } from "@/lib/branding";
import { useDocsI18n } from "@/lib/i18n";

export function StatusLink() {
	const { t } = useDocsI18n();

	return (
		<a
			href={getStatusUrl()}
			target="_blank"
			rel="noopener noreferrer"
			className="flex items-center justify-center gap-2 py-2 text-xs text-fd-muted-foreground hover:text-fd-foreground transition-colors"
		>
			<span className="relative flex h-2 w-2">
				<span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" />
				<span className="relative inline-flex h-2 w-2 rounded-full bg-green-500" />
			</span>
			{t("status.operational")}
		</a>
	);
}
